import { contactUs, supportMail } from '@/constants/constants';
import { useNote } from '@/context/NoteProvider';
import { colors } from '@/theme';
import { Box, Link, Typography, colors as muiColors } from '@mui/material';

interface ErrorStateProps {
  message?: string | undefined;
}

const ErrorState = ({ message }: ErrorStateProps) => {
  const noteContext = useNote();
  const text = message ?? noteContext.error ?? '';

  return (
    <Box sx={{ padding: 2 }}>
      <Typography
        variant="body1"
        color={colors.error}
        mt={2}
        sx={{
          backgroundColor: `${colors.lightBlue[1000]}`,
          borderRadius: '20px 20px 0px 0px',
          margin: '0 auto',
        }}
        textAlign="center"
        pt={2}
        px={2}
      >
        {text}
      </Typography>
      <Typography
        textAlign="center"
        variant="body1"
        color={muiColors.green[50]}
        py={2}
        sx={{
          backgroundColor: colors.lightBlue[1000],
          borderRadius: '0px 0px 20px 20px',
        }}
      >
        {contactUs}
        <Link
          href="mailto:support@scribebrain.ai"
          color={muiColors.green[50]}
        >
          {supportMail}
        </Link>
      </Typography>
    </Box>
  );
};

export default ErrorState;
